var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImportUsersModal',{attrs:{"handleCancel":_vm.handleCancel,"headerIcon":_vm.headerIcon,"headerText":"Workday Import","importType":"workday","itemType":_vm.itemType,"visible":true},scopedSlots:_vm._u([{key:"selectionComponent",fn:function(){return [_c('WorkdayImportSelection',{attrs:{"workdayId":_vm.workdayId}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }